import { z } from "zod";
export const ServiceReferenceSchema = z.object({ id: z.string().min(1) });
const nullableReference = z.union([
    ServiceReferenceSchema,
    z.literal("").transform(() => null),
    z.null(),
]);
const shape = {
    id: z.string().min(1).optional(),
    manualLabel: z
        .string()
        .nullable()
        .transform((value) => (value === "" ? null : value))
        .optional(),
    manualAmount: z
        .union([z.number().finite(), z.null(), z.literal("").transform(() => null)])
        .optional(),
    quantity: z.number().finite(),
    description: nullableReference.optional(),
    target: nullableReference.optional(),
    event: z
        .union([
        nullableReference,
        z
            .string()
            .min(1)
            .transform((id) => ({ id })),
    ])
        .optional(),
    index: z.number().int().optional(),
    deleted: z.boolean().optional(),
};
export const CreateServicePayloadSchema = z.object(shape);
export const UpdateServicePayloadSchema = CreateServicePayloadSchema.partial().extend({
    id: z.string().min(1),
});
//# sourceMappingURL=write-payloads.js.map